import ModelMappingOrigin from "~/models/mapping/modelMappingOrigin";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import MappingOriginSalesforce from "~/models/mapping/mappingOriginSalesforce";
import {ISChildRelationship, ISField, ISObjectDescribe, ISSchema} from "~/interfaces/salesforceInterfaces";
import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import {sfUploaderOrigin} from "~/models/mapping/salesforceHelpers/fileUploaderHelper";

export default class ModelMappingOriginSChildRelationship extends ModelMappingOrigin<ISChildRelationship, MappingOriginSalesforce> {
  get schema(): ISSchema {
    return this.mappingOrigin._salesforceSchema
  }

  get origin(): ISChildRelationship {
    return (<MappingOriginSalesforce>this.mappingOrigin).root.objectDescribed.childRelationships
      .find(x => x.relationshipName === this.id)
  }

  get identifier(): string {
    return this.origin?.relationshipName
  }

  get title(): string {
    return this.origin?.relationshipName
  }

  get values(): ISField[] {
    return this.childSObject.fields
  }

  valueOptions(source: ModelMappingValueOrigin = null): IDefaultVOption[] {
    if (!Array.isArray(this.values)) return []
    return this.values.map(field => {
      return {label: field.name, value: field.name, labelSuffix: `(${field.type})`}
    })
  }

  get uploaderValueOptions(): IDefaultVOption[] {
    return [{label: sfUploaderOrigin.label, value: sfUploaderOrigin.name, labelSuffix: `(${sfUploaderOrigin.type})`}];
  }

  isSingle: boolean = false

  searchValues(query?: string, options: { filters?: ((value: string) => boolean)[], showUnmappedOnly?: boolean } = {}): Partial<this['values']> {
    const filters = [value => (value.label || value.name)?.toLowerCase()?.trim()?.includes(query?.toLowerCase()?.trim())]
    if (options.showUnmappedOnly) {
      filters.unshift(value => {
        return !this.modelMapping.isMapped(value.name)
      })
    }
    return this.values.filter(value => filters.every(f => f(value)))
  }

  mapValueToOption(value): IDefaultVOption {
    return {
      label: value === sfUploaderOrigin ? value.label : value.name,
      value: value.name,
      labelSuffix: `(${value.type})`
    }
  }

  get childSObjectName(): string {
    return this.origin.childSObject
  }

  private get childSObject(): ISObjectDescribe {
    return this.schema.object_describes[this.childSObjectName]
  }
}
